import { ThemeProvider } from '@mui/material'
import PageContainer from 'layouts/PageContainer'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { fontTheme } from '../../styles/font'
import SettingsManagmentList from './SettingsManagment'
import FeedingPlanCard from './components/feeding-plan/FeedingPlanCard'

import { useAppSelector } from 'store/hooks'
import MilkingScheduleCard from './components/milking-schedule/MilkingScheduleCard'
import PlannedEventsCard from './components/planned-events/PlannedEventsCard'

const theme = fontTheme

const SettingPage = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)

	const isShowPlannedEvents =
		permissions.license_limpness && !userData?.isLamenessExpired
	const isShowMilkingSchedule =
		permissions.license_milking_process_check ||
		permissions.license_identification
	return (
		<ThemeProvider theme={theme}>
			<PageContainer>
				<TypographySecondary>Основные</TypographySecondary>
				<SettingsManagmentList />
				<TypographySecondary>Расписание событий</TypographySecondary>
				{isShowPlannedEvents && <PlannedEventsCard />}
				{isShowMilkingSchedule && <MilkingScheduleCard />}
				{permissions.license_food_table && <FeedingPlanCard />}
			</PageContainer>
		</ThemeProvider>
	)
}

export default SettingPage
